import React from "react";

const DataLoader = () => {
  return (
    <div className="py-5 mx-auto">
      <span className="loader-box mx-auto"></span>
    </div>
  );
};

export default DataLoader;
